import { css } from "@strust/ui/css";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import { loginMessages } from "../messages.ts";
import { AuthHeading, AuthLayout, AuthNote } from "./auth-layout.tsx";
import { LoginForm, type LoginFormProps } from "./login-form.tsx";

const STATUS = css({ textStyle: "caption", color: "text.2", m: "0" });

export interface LoginScreenProps extends LoginFormProps {
  /** The browser is being sent to the organization's identity provider. */
  readonly redirecting?: boolean;
  /**
   * "Forgot password?" link to the self-service reset (router link rendered by the container);
   * absent while the release flag iam.password-reset is off.
   */
  readonly forgotPassword?: ReactNode;
}

/** The login screen as a whole (brand panel, card, audited-access note); presentational. */
export function LoginScreen({ redirecting, forgotPassword, ...form }: LoginScreenProps) {
  const intl = useIntl();
  return (
    <AuthLayout>
      <AuthHeading
        title={intl.formatMessage(loginMessages.title)}
        subtitle={intl.formatMessage(loginMessages.ssoHint)}
      />
      <LoginForm {...form} />
      {forgotPassword}
      {redirecting ? (
        <p role="status" className={STATUS}>
          {intl.formatMessage(loginMessages.redirecting)}
        </p>
      ) : null}
      <AuthNote>{intl.formatMessage(loginMessages.auditNote)}</AuthNote>
    </AuthLayout>
  );
}
